module.exports = __webpack_public_path__ + "static/img/enterprise-invest-hover.e0cab4c9.png";